// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
'use client';
import React from 'react';
import useBaseComponent from '../internal/hooks/use-base-component';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import { getExternalProps } from '../internal/utils/external-props';
import InternalTooltip from './internal';
export default function Tooltip({ position = 'top', ...rest }) {
    const baseComponentProps = useBaseComponent('Tooltip', {
        props: { position },
    });
    const externalProps = getExternalProps(rest);
    return React.createElement(InternalTooltip, { position: position, ...externalProps, ...baseComponentProps });
}
applyDisplayName(Tooltip, 'Tooltip');
//# sourceMappingURL=index.js.map